import React, { lazy, Suspense, useEffect, useRef } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import JwtAuthService from "services/JwtAuthService";
import MenuService from "services/MenuService";

export const AppViews = () => {
	let intervalId = useRef(null);

	const populateMenu = async () => {
		try {
			if (JwtAuthService.isLogged()) {
				await MenuService.populateMenuData();
			}
		} catch (e) {}

		intervalId.current = setInterval(async () => {
			if (JwtAuthService.isLogged()) {
				MenuService.populateMenuData();
			}
		}, 30000);
	};

	useEffect(() => {
		populateMenu();

		return () => {
			clearInterval(intervalId.current);
		};
	}, []);

	return (
		<Suspense fallback={<Loading cover="content" />}>
			<Switch>
				<Route
					path={`${APP_PREFIX_PATH}/dashboard`}
					component={lazy(() => import(`./dashboard`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dados-conta`}
					component={lazy(() => import(`./dados-conta`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-usuarios`}
					component={lazy(() => import(`./lista-usuarios`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/usuario/:id`}
					component={lazy(() => import(`./usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/usuario`}
					component={lazy(() => import(`./usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-grupos-usuario`}
					component={lazy(() => import(`./lista-grupos-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupo-usuario/:id`}
					component={lazy(() => import(`./grupo-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupo-usuario`}
					component={lazy(() => import(`./grupo-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-sistema-operacional`}
					component={lazy(
						() => import(`./lista-sistema-operacional`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/sistema-operacional/:id`}
					component={lazy(() => import(`./sistema-operacional`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/sistema-operacional`}
					component={lazy(() => import(`./sistema-operacional`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-modelo-maquina`}
					component={lazy(() => import(`./lista-modelo-maquina`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/modelo-maquina/:id`}
					component={lazy(() => import(`./modelo-maquina`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/modelo-maquina`}
					component={lazy(() => import(`./modelo-maquina`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-categoria-driver`}
					component={lazy(() => import(`./lista-categoria-driver`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/categoria-driver/:id`}
					component={lazy(() => import(`./categoria-driver`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/categoria-driver`}
					component={lazy(() => import(`./categoria-driver`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-driver`}
					component={lazy(() => import(`./lista-driver`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/driver/:id`}
					component={lazy(() => import(`./driver`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/driver`}
					component={lazy(() => import(`./driver`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-maquina`}
					component={lazy(() => import(`./lista-maquina`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/maquina/:id`}
					component={lazy(() => import(`./maquina`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/maquina`}
					component={lazy(() => import(`./maquina`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-versao-sistema`}
					component={lazy(() => import(`./lista-versao-sistema`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/versao-sistema/:id`}
					component={lazy(() => import(`./versao-sistema`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/versao-sistema`}
					component={lazy(() => import(`./versao-sistema`))}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}`}
					to={`${APP_PREFIX_PATH}/dashboard`}
				/>
			</Switch>
		</Suspense>
	);
};

export default React.memo(AppViews);
